import{useMemo as r}from"react";import{useSearchBox as t}from"react-instantsearch";const o=()=>{const o=r((()=>({queryHook:()=>{}})),[]);return t(o)};export{o as useReadonlySearchBox};
